export enum ConsumerDobFormErrorMessageId {
  InvalidDobFormat = 'invalid-dob-format',
  MinAgeRequirement = 'min-age-requirement'
}
